import Cookies from 'js-cookie'

//Login
export const isLoggedIn = () => {
  const sessionBase = Cookies.get('SESSION')
  if (sessionBase) {
    return true
  } else {
    return false
  }
}

export const getSession = () => {
  const sessionBase = Cookies.get('SESSION')
  if (sessionBase) {
    let session = []
    try {
      const { userId, token, role, ssFlg } = JSON.parse(atob(sessionBase))
      session.push(userId)
      session.push(token)
      session.push(role)
      session.push(ssFlg)
    } catch (err) {
      return []
    }
    return session
  } else {
    return []
  }
}

//CisUser 
export const cisUser = (rolename: string): boolean => {
  const roleemployee = process.env.REACT_APP_ROLE_EMPLOYEE!
  const regexp = new RegExp(roleemployee)
  if (rolename.match(regexp)) {
    return true
  } else {
    return false
  }
}

//SsUser 
export const ssUser = (ssflg: string): boolean => {
  if (ssflg === '1') {
    return true
  } else {
    return false
  }
}

//AdminUser
export const adminUser = (rolename: string): boolean => {
  const roleadmin = process.env.REACT_APP_ROLE_ADMIN!
  const regexp = new RegExp(roleadmin)
  if (rolename.match(regexp)) {
    return true
  } else {
    return false
  }
}


//QAList Result
export const isSessionStorage = () => {
  const storage = sessionStorage.getItem('SESSIONLIST')
  if (storage) {
    return true
  } else {
    return false
  }
}

export const getSessionStorage = () => {
  const storage = sessionStorage.getItem('SESSIONLIST')
  if (storage) {
    let ls = []
    try {
      const { pageindex, pagesort } = JSON.parse(decodeURIComponent(escape(atob(storage))))
      ls.push(pageindex)
      ls.push(pagesort)
    } catch (err) {
      console.log(err)
      return []
    }
    return ls
  } else {
    return []
  }
}

export const removeSessionStorage = () => {
  sessionStorage.removeItem('SESSIONLIST')
}


//QAList Form
export const isSessionStorageForm = () => {
  const storage = sessionStorage.getItem('SESSIONFORM')
  if (storage) {
    return true
  } else {
    return false
  }
}

export const getSessionStorageForm = () => {
  const storage = sessionStorage.getItem('SESSIONFORM')
  if (storage) {
    let resform = []
    try {
      const form = JSON.parse(decodeURIComponent(escape(atob(storage))))
      resform.push(form)
    } catch {
      return []
    }
    return resform
  } else {
    return []
  }
}

export const removeSessionStorageForm = () => {
  sessionStorage.removeItem('SESSIONFORM')
}

//Contract Result
export const isSessionStorageCon = () => {
  const storage = sessionStorage.getItem('SESSIONCON')
  if (storage) {
    return true
  } else {
    return false
  }
}

export const getSessionStorageCon = () => {
  const storage = sessionStorage.getItem('SESSIONCON')
  if (storage) {
    let ls = []
    try {
      const { pageindex, pagesort } = JSON.parse(decodeURIComponent(escape(atob(storage))))
      ls.push(pageindex)
      ls.push(pagesort)
    } catch (err) {
      console.log(err)
      return []
    }
    return ls
  } else {
    return []
  }
}

export const removeSessionStorageCon = () => {
  sessionStorage.removeItem('SESSIONCON')
}


//Contract Form
export const isSessionStorageConForm = () => {
  const storage = sessionStorage.getItem('SESSIONCONFORM')
  if (storage) {
    return true
  } else {
    return false
  }
}

export const getSessionStorageConForm = () => {
  const storage = sessionStorage.getItem('SESSIONCONFORM')
  if (storage) {
    let resform = []
    try {
      const form = JSON.parse(decodeURIComponent(escape(atob(storage))))
      resform.push(form)
    } catch {
      return []
    }
    return resform
  } else {
    return []
  }
}

export const removeSessionStorageConForm = () => {
  sessionStorage.removeItem('SESSIONCONFORM')
}

